export interface IDisabledReason {
  id: string;
  reason: string;
}
